export const AWSNAP_ROUTE_TEMPLATE = "/absdk/error/unableToLoad";
export function registerRoute(routeRegistry) {
  return routeRegistry.registerRoute({
    routeTemplate: AWSNAP_ROUTE_TEMPLATE,
    routeTitle: "Error: Unable to load view",
    view: {
      modulePath: () => import(/* webpackChunkName: "Builtin_Routes" */"abreact/incubator/ui/app/routes/AwSnapView"),
      exportName: "AwSnapView"
    }
  });
}
//# sourceMappingURL=AwSnapRoute.js.map
